import { Database, BarChart3, Gauge, Camera, Clock } from 'lucide-react'
import { useApi } from '../../hooks/useApi'

interface StatsData {
  totalKeywords: number
  withVolume: number
  withKd: number
  totalSnapshots: number
  avgAgeHours: number
}

function getFreshnessColor(hours: number): string {
  if (hours <= 24) return '#10B981'
  if (hours <= 72) return '#84CC16'
  if (hours <= 168) return '#FBBF24'
  if (hours <= 336) return '#F97316'
  return '#EF4444'
}

function Skeleton() {
  return <div className="animate-pulse bg-[#E2E4ED] rounded h-8 w-20" />
}

export default function GlobalDbStats() {
  const { data, loading } = useApi<StatsData>('/api/admin/global-db/stats')

  const kpis = [
    { label: 'Total Keywords', value: data?.totalKeywords?.toLocaleString('fr-FR'), icon: Database, color: '#6366F1' },
    { label: 'With Volume', value: data?.withVolume?.toLocaleString('fr-FR'), icon: BarChart3, color: '#A855F7' },
    { label: 'With KD Score', value: data?.withKd?.toLocaleString('fr-FR'), icon: Gauge, color: '#F97316' },
    { label: 'Total Snapshots', value: data?.totalSnapshots?.toLocaleString('fr-FR'), icon: Camera, color: '#6366F1' },
    {
      label: 'Avg Freshness',
      value: data ? `${Math.round(data.avgAgeHours)}h` : undefined,
      icon: Clock,
      color: data ? getFreshnessColor(data.avgAgeHours) : '#8B8FA7',
    },
  ]

  return (
    <div className="bg-white rounded-xl border border-[#E2E4ED] p-5">
      <h2 className="text-lg font-semibold text-[#1B2559] mb-4">Statistiques</h2>
      <div className="grid grid-cols-2 gap-4">
        {kpis.map((kpi) => (
          <div key={kpi.label} className="flex items-start gap-3">
            <div
              className="p-2 rounded-lg shrink-0"
              style={{ backgroundColor: `${kpi.color}14` }}
            >
              <kpi.icon size={18} strokeWidth={1.25} style={{ color: kpi.color }} />
            </div>
            <div>
              {loading ? (
                <Skeleton />
              ) : (
                <p className="text-2xl font-bold text-[#1B2559]">{kpi.value ?? '-'}</p>
              )}
              <p className="text-sm text-[#8B8FA7]">{kpi.label}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
